// @flow
import React from 'react';
import { injectIntl } from 'react-intl';
import type { InjectIntlProvidedProps } from 'react-intl';
import DisabledFormIcon from '../../../icons/disabled-form';
import messages from './messages';
import css from './disabled-form-page.module.scss';

type Props = InjectIntlProvidedProps;

const DisabledFormPage = (props: Props) => {
  const { intl } = props;

  return (
    <div className={css.container}>
      <DisabledFormIcon />
      <div className={css.message}>
        {intl.formatMessage(messages.disabledFormMessage)}
      </div>
    </div>
  );
};

export { DisabledFormPage };
export default injectIntl(DisabledFormPage);
